module.exports = __webpack_public_path__ + "static/media/main-header-bg.e81ecf89.jpg";